import { useTranslation } from 'react-i18next'
import { Button, H2 } from '@/components/atoms'
import { FeatureItem } from '@/components/molecules'
import { useRentersStepSixPage } from './page.onboarding-renters-step-six.hook'

interface RentersStepSixPageProps {
  onContinue: () => void
  onBack: () => void
}

export function RentersStepSixPage({
  onContinue,
  onBack,
}: RentersStepSixPageProps) {
  const { t } = useTranslation()
  const { features } = useRentersStepSixPage()

  return (
    <div className="flex h-full flex-col">
      <div className="min-h-0 flex-1 overflow-y-auto pb-4 md:flex md:flex-row md:justify-between md:gap-8 md:pb-0">
        <div className="flex flex-col justify-between gap-6 md:max-w-94">
          <H2 className="text-[2rem]! leading-8! text-neutral-900 md:my-auto md:text-[3.125rem]! md:leading-15!">
            {t('onboarding.renters.stepSix.title')}
          </H2>

          <div className="hidden gap-3 md:flex">
            <Button
              variant="secondary"
              onClick={onBack}
              data-testid="step-six-back"
              className="h-12 md:mb-2.5"
            >
              {t('onboarding.back')}
            </Button>
            <Button
              onClick={onContinue}
              data-testid="step-six-finish"
              className="h-12 md:mb-2.5"
            >
              {t('onboarding.continue')}
            </Button>
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-6 md:mt-0 md:max-w-89.5 md:justify-center md:gap-8">
          {features.map((feature, i) => (
            <FeatureItem
              key={i}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>

      <div className="flex w-full gap-3 pt-4 md:hidden">
        <Button
          variant="secondary"
          onClick={onBack}
          className="h-12 w-full"
          data-testid="step-six-back"
        >
          {t('onboarding.back')}
        </Button>
        <Button
          onClick={onContinue}
          className="h-12 w-full"
          data-testid="step-six-finish"
        >
          {t('onboarding.continue')}
        </Button>
      </div>
    </div>
  )
}
